var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticStyle: {
        display: "flex",
        "flex-direction": "column",
        gap: "16px",
        "min-width": "800px"
      }
    },
    [
      _c(
        "div",
        { staticClass: "tags-wrapper", staticStyle: { "min-width": "800px" } },
        [
          _c(
            "div",
            { staticClass: "tags-container" },
            _vm._l(_vm.selectedCnaes, function(cnae) {
              return _c(
                "b-badge",
                {
                  key: cnae,
                  staticClass: "tag-item",
                  attrs: { variant: "info" },
                  on: {
                    click: function($event) {
                      return _vm.removeTag(cnae)
                    }
                  }
                },
                [
                  _c("span", [_vm._v(_vm._s(_vm.getCnaeText(cnae)))]),
                  _vm._v(" "),
                  _c("b-icon-x-circle", { staticClass: "ml-1" })
                ],
                1
              )
            }),
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-dropdown",
        {
          staticClass: "mb-3",
          attrs: {
            disabled: _vm.disabled,
            text: "Selecione CNAEs",
            variant: "primary"
          }
        },
        [
          _c(
            "b-dropdown-form",
            { staticStyle: { "min-width": "800px", height: "100%" } },
            [
              _c(
                "b-form-group",
                { attrs: { label: "Buscar CNAE:" } },
                [
                  _c("b-form-input", {
                    staticClass: "mb-2",
                    attrs: { placeholder: "Digite para filtrar..." },
                    model: {
                      value: _vm.search,
                      callback: function($$v) {
                        _vm.search = $$v
                      },
                      expression: "search"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "dropdown-scroll" },
                [
                  _vm.isLoading
                    ? _c(
                        "div",
                        { staticClass: "d-flex align-items-center mb-2" },
                        [
                          _c("b-spinner", {
                            attrs: {
                              small: "",
                              type: "grow",
                              label: "Carregando..."
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "ml-2" }, [
                            _vm._v("Carregando CNAEs...")
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.filteredCnaes, function(cnae) {
                    return !_vm.isLoading
                      ? _c(
                          "b-form-checkbox",
                          {
                            key: cnae.value,
                            attrs: { value: cnae.value },
                            on: { change: _vm.handleChange },
                            model: {
                              value: _vm.selectedCnaes,
                              callback: function($$v) {
                                _vm.selectedCnaes = $$v
                              },
                              expression: "selectedCnaes"
                            }
                          },
                          [
                            _vm._v(
                              "\n          " + _vm._s(cnae.text) + "\n        "
                            )
                          ]
                        )
                      : _vm._e()
                  })
                ],
                2
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }